import {
  CapaQuotationChatMessageType,
  CapaQuotationChatRoomStatus,
  CapaQuotationPartnerUserStatus,
  CapaRfqStatus,
  CapaQuotationChatRoom
} from '@generated/graphql';
import { formatDate } from '@utils/formatter';
import { ApplicableToClientMessageTypes, CommonMessageType } from './types';

export const isNextDay = (prevDate: any, currDate: any) => {
  const convertPrev = formatDate(prevDate as string, 'YYYY-MM-DD');

  const convertNext = formatDate(currDate as string, 'YYYY-MM-DD');

  return new Date(convertPrev).toString() !== new Date(convertNext).toString();
};

export const isCommonMessageType = (
  messageType?: CapaQuotationChatMessageType
) => {
  if (!messageType) return false;

  return CommonMessageType.includes(messageType);
};

export const isApplicableClientType = (
  messageType?: CapaQuotationChatMessageType
) => {
  if (!messageType) return false;

  return ApplicableToClientMessageTypes.includes(messageType);
};

interface IsClosedParams {
  rfqStatus?: CapaRfqStatus;
  roomStatus?: CapaQuotationChatRoomStatus;
}

export const getConsultingStatus = ({
  rfqStatus,
  roomStatus
}: IsClosedParams) => {
  if (roomStatus === CapaQuotationChatRoomStatus.ClosedConfirm) {
    return 'CLOSED';
  }

  // 상담 종료 (고객)
  if (roomStatus === CapaQuotationChatRoomStatus.ClosedClient) {
    return 'CLOSED';
  }

  // 상담 종료 (파트너)
  if (roomStatus === CapaQuotationChatRoomStatus.ClosedPartner) {
    return 'CLOSED';
  }

  // 거래완료
  if (rfqStatus === CapaRfqStatus.Complete) {
    return 'CLOSED';
  }

  // 중단
  if (roomStatus === CapaQuotationChatRoomStatus.Stopped) {
    return 'CLOSED';
  }

  return 'OPEND';
};

export const setMenuStatus = (room?: CapaQuotationChatRoom) => {
  const status = getConsultingStatus({
    rfqStatus: room?.rfqStatus ?? undefined,
    roomStatus: room?.chatRoomStatus ?? undefined
  });

  const isWithdrawPartner =
    room?.partnerStatus === CapaQuotationPartnerUserStatus.Deleted;

  const isOld = room?.isOld;

  const hasPurchaseOrder = room?.hasPurchaseOrder;

  const hasQuotation = room?.hasQuotation;

  const hasConfirmedQuotation = room?.isQuotationConfirmed;

  if (isWithdrawPartner) {
    if (!hasConfirmedQuotation && !hasPurchaseOrder) {
      return {
        viewer: false,
        drawingfileManagement: false,
        request: false,
        quotation: false,
        purchaseOrder: true
      };
    }

    return {
      viewer: false,
      drawingfileManagement: false,
      request: false,
      quotation: false,
      purchaseOrder: false
    };
  }

  if (status === 'CLOSED') {
    if (isOld) {
      if (!hasQuotation && !hasPurchaseOrder) {
        return {
          viewer: false,
          drawingfileManagement: false,
          request: false,
          quotation: true,
          purchaseOrder: true
        };
      }

      if (!hasQuotation && hasPurchaseOrder) {
        return {
          viewer: false,
          drawingfileManagement: false,
          request: false,
          quotation: true,
          purchaseOrder: false
        };
      }

      if (hasQuotation && !hasPurchaseOrder) {
        return {
          viewer: false,
          drawingfileManagement: false,
          request: false,
          quotation: false,
          purchaseOrder: true
        };
      }

      return {
        viewer: false,
        drawingfileManagement: false,
        request: false,
        quotation: false,
        purchaseOrder: false
      };
    } else {
      if (!hasPurchaseOrder) {
        return {
          viewer: false,
          drawingfileManagement: false,
          request: false,
          quotation: false,
          purchaseOrder: true
        };
      }

      return {
        viewer: false,
        drawingfileManagement: false,
        request: false,
        quotation: false,
        purchaseOrder: false
      };
    }
  }
  return {
    viewer: false,
    drawingfileManagement: false,
    request: false,
    quotation: false,
    purchaseOrder: false
  };
};
